export const iconFontAwesomeMoneyRubleSign = (
	<i className="fa-solid fa-ruble-sign"></i>
);
